import React from 'react';
import { LockIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { useUi } from '../../contexts/UiContext';
import { WeekRow } from '../../types/shared';
import { PageHeader } from '../../components/ui/PageHeader';
import { Button } from '../../components/ui/Button';
import { Avatar } from '../../components/Avatar';
export function WeekClose() {
  const {
    family,
    activeMembers,
    weekFor,
    weekDraftFor,
    setWeekDraft,
    closeWeek,
    weekClose,
    memberById
  } = useAppState();
  const {
    openSub
  } = useUi();
  const r = family.rules;
  const kids = activeMembers.filter(m => m.role === 'otrok');
  const rows: WeekRow[] = kids.map(m => {
    const w = weekFor(m.id);
    const d = weekDraftFor(m.id);
    const eligible = w.reached || Boolean(d.override);
    return {
      memberId: m.id,
      pct: w.pct,
      reached: w.reached,
      override: Boolean(d.override),
      paid: Boolean(d.paid),
      amount: eligible ? r.allowanceAmount : 0
    };
  });
  const shown = weekClose ? weekClose.rows : rows;
  return <div className="mx-auto max-w-3xl" data-id="element-1382" data-mp="23j48ft4gf1wi">
      <PageHeader title="Tedenski zaključek" subtitle={`Teden 5.–11. oktober · kačing pri ${r.basicThresholdPct} % cvenkotočk · žepnina ${r.allowanceAmount} ${r.currency}`} onBack={() => openSub(null)} backLabel="Pregled" data-id="element-1383" data-mp="28gw2asonsy3c" />
      {weekClose && <p className="mb-4 flex items-center gap-2 rounded-2xl bg-done-soft px-4 py-3 text-sm font-bold text-done-ink" data-id="element-1384" data-mp="2hfhkgmq7yb3l">
          <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-1385" data-mp="2rfi4kavwwv8u" /> Zaključil(a) {memberById(weekClose.closedBy)?.name}. Teden je zaklenjen s takratnimi vrednostmi.
        </p>}
      <div className="overflow-hidden rounded-3xl border-[1.5px] border-line bg-surface" data-id="element-1386" data-mp="2w8kywl8ik8q3">
        <table className="w-full text-sm" data-id="element-1387" data-mp="314s060pysw1p">
          <thead className="bg-canvas text-left text-xs font-bold text-muted" data-id="element-1388" data-mp="357oj5sjf2u66">
            <tr data-id="element-1389" data-mp="3a69at3kls5j0">
              <th className="px-4 py-3" data-id="element-1390" data-mp="3a5q4kk4bf5kt">Član</th>
              <th className="px-2 py-3 text-right" data-id="element-1391" data-mp="3a6izmntww6n4">Osnovni plan</th>
              <th className="hidden px-2 py-3 sm:table-cell" data-id="element-1392" data-mp="1a51nkho1qdxm">Izjema po presoji</th>
              <th className="px-2 py-3 text-right" data-id="element-1393" data-mp="162y7tgucgn6j">Znesek</th>
              <th className="px-4 py-3 text-right" data-id="element-1394" data-mp="160li2hich8ix">Izplačilo</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-line" data-id="element-1395" data-mp="1jvw6pd5zwxeu">
            {shown.map(row => {
            const m = memberById(row.memberId);
            if (!m) return null;
            return <tr key={row.memberId} data-id="element-1396" data-mp="1tu3lpqgq55e7">
                  <td className="px-4 py-3" data-id="element-1397" data-mp="1otpeubqv01hr">
                    <span className="flex items-center gap-2 font-bold" data-id="element-1398" data-mp="1osmr2cou2f62">
                      <Avatar member={m} size="sm" data-id="element-1399" data-mp="22re0vmwnxeoe" /> {m.name}
                    </span>
                  </td>
                  <td className={`px-2 py-3 text-right font-extrabold tabular-nums ${row.reached ? 'text-done-ink' : 'text-accent-ink'}`} data-id="element-1400" data-mp="1xu439jz4dwph">{row.pct} %</td>
                  <td className="hidden px-2 py-3 sm:table-cell" data-id="element-1401" data-mp="3ftfzfy6balt">
                    {!row.reached && <label className="flex items-center gap-2" data-id="element-1402" data-mp="2f2et14i32et1">
                        <input type="checkbox" className="h-4 w-4 accent-[#C24E28]" disabled={Boolean(weekClose)} checked={row.override} onChange={e => setWeekDraft(row.memberId, {
                    override: e.target.checked
                  })} data-id="element-1403" data-mp="2f59bwrlg7rkc" />
                        <span className="text-xs" data-id="element-1404" data-mp="2abychbiyud2g">odobri</span>
                      </label>}
                  </td>
                  <td className="px-2 py-3 text-right font-bold tabular-nums" data-id="element-1405" data-mp="1wbdwso8ckxd6">
                    {row.amount} {r.currency}
                  </td>
                  <td className="px-4 py-3 text-right" data-id="element-1406" data-mp="2195n5dtcgbf9">
                    {row.paid ? <span className="rounded-full bg-done-soft px-2 py-0.5 text-xs font-bold text-done-ink" data-id="element-1407" data-mp="1ne3i0swbmq3i">Izplačano</span> : row.amount > 0 && !weekClose ? <Button size="sm" variant="secondary" onClick={() => setWeekDraft(row.memberId, {
                  paid: true
                })} data-id="element-1408" data-mp="3hqjj7fa9fe1i">
                        Označi kot izplačano
                      </Button> : <span className="text-xs text-muted" data-id="element-1409" data-mp="2wycx4jsb45v0">–</span>}
                  </td>
                </tr>;
          })}
          </tbody>
        </table>
      </div>
      <p className="mt-3 text-xs text-muted" data-id="element-1410" data-mp="2i3gkzvhdmycn">
        Izplačilo žepnine, poraba goodies in potrjevanje opravil so tri ločena dejanja. Istega tedna ni mogoče izplačati dvakrat. Stanje goodies se prenese v naslednji teden.
      </p>
      {!weekClose && <Button size="lg" className="mt-5 w-full sm:w-auto" onClick={() => closeWeek(rows)} data-id="element-1411" data-mp="29ad1p6k1vra3">
          <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-1412" data-mp="24ctl3zzvr2ez" /> Zaključi teden
        </Button>}
    </div>;
}